import React from 'react'
import { IconWrapper } from '../IconWrapper'
import type { IconWrapperProps } from '../IconWrapper'

export const BbxAppBoticarioIcon = React.forwardRef<SVGSVGElement, IconWrapperProps>(
  (props, forwardedRef) => {
    return (
      <IconWrapper {...props}>
        <svg
          width="24"
          height="24"
          viewBox="0 0 24 24"
          fill="none"
          xmlns="http://www.w3.org/2000/svg"
          {...props}
          ref={forwardedRef}
        >
          <path
            d="M15.5776 2.65918H8.4408C5.2488 2.65918 2.652 5.25598 2.652 8.44798V15.5848C2.652 18.7768 5.2488 21.3736 8.4408 21.3736H15.5776C18.7696 21.3736 21.3664 18.7768 21.3664 15.5848V8.44798C21.3664 5.25598 18.7696 2.65918 15.5776 2.65918ZM20.4752 15.5848C20.4752 18.2856 18.2776 20.4824 15.5776 20.4824H8.4408C5.74 20.4824 3.5432 18.2848 3.5432 15.5848V8.44798C3.5432 5.74718 5.7408 3.55038 8.4408 3.55038H15.5776C18.2784 3.55038 20.4752 5.74798 20.4752 8.44798V15.5848Z"
            fill="#222"
          />
          <path
            d="M13.2104 8.87678C13.0784 8.78318 12.952 8.59438 12.9424 8.44078C12.9368 8.35198 13.1544 8.21358 13.2904 8.15038C13.7152 7.95598 13.7848 7.82238 13.8032 7.28958C13.8184 6.85918 13.596 6.66878 13.2672 6.56878C12.3976 6.30638 11.528 6.30398 10.6656 6.61598C10.3456 6.73118 10.2208 6.95038 10.204 7.32158C10.1824 7.81438 10.4272 8.01358 10.8 8.15838C10.916 8.20238 11.0752 8.34958 11.0752 8.44878C11.0712 8.53198 11.0504 8.61278 11.016 8.68718C10.9808 8.76158 10.932 8.82718 10.872 8.87998C9.6992 9.73998 9.3104 10.7152 9.6712 12.1904C9.824 12.8152 10.0792 13.4208 10.3552 13.9984C10.784 14.8944 10.8896 15.76 10.3552 16.6432C10.3024 16.736 10.2568 16.8328 10.2192 16.9336C10.044 17.38 10.1632 17.6176 10.6152 17.6424C11.0904 17.6688 11.5656 17.648 12.0408 17.648L12.0352 17.6432C12.5352 17.6432 13.0344 17.672 13.5288 17.6352C13.9728 17.6 14.0896 17.3048 13.8368 16.9088C13.2072 15.9208 13.0888 14.9368 13.6904 13.8576C13.9936 13.316 14.2 12.6936 14.3552 12.0816C14.7024 10.72 14.2896 9.65918 13.2088 8.87598L13.2104 8.87678Z"
            fill="#222"
          />
        </svg>
      </IconWrapper>
    )
  },
)
